module.exports = __webpack_public_path__ + "img/jaylen_waddle.50e5bbf7.png";